import { loadModules, loadCss } from "esri-loader"
import appConfig from "@/modules/appConfig"
import { useMapStore } from "@/store/modules/map"
import { createLayer } from "@/modules/esriLayer"
import { str2JSON } from "@/utils/index"

const mapStore = useMapStore()

const option = {
  // api: "/library/4.18/dojo/dojo.js",
  // css: "/library/4.18/esri/css/main.css",
  // font: "/library/ArcGIS_pbf_Font"
  // api: process.env.NODE_ENV === "production" ? "/library/4.18/dojo/dojo.js" : "/library/arcgis/4.18/dojo/dojo.js",
  // css:
  //   process.env.NODE_ENV === "production"
  //     ? "/library/4.18/esri/css/main.css"
  //     : "/library/arcgis/4.18/esri/css/main.css",
  api: "/library/4.18/dojo/dojo.js",
  css: "/library/4.18/esri/css/main.css",
  font: "/library/ArcGIS_pbf_Font"
}

// 模块存放
const moduleStore: any = {}

/**
 * 初始化
 **/

export const init = () => {
  const promise = new Promise<any[]>((resolve: any) => {
    loadCss(option.css)
    getModules(["esri/config"]).then((modules) => {
      const [config] = modules
      config.fontsUrl = option.font
      config.log.level = "none"
      resolve()
    })
  })
  return promise
}

/**
 * @param modulePaths arcgis api 模块途径
 **/
export const getModules = (modulePaths: string[]) => {
  const promise = new Promise<any[]>((resolve, reject) => {
    const arr: Promise<any>[] = []
    modulePaths.forEach((path) => {
      arr.push(getModule(path))
    })
    Promise.all(arr)
      .then((modules) => {
        resolve(modules)
      })
      .catch((e) => {
        reject(e)
      })
  })
  return promise
}

// 获取单个模块
export const getModule = (path: string) => {
  const promise = new Promise<any>((resolve, reject) => {
    const name = path.split("/").pop() as string
    if (moduleStore[name]) {
      resolve(moduleStore[name])
    } else {
      loadModules([path], { url: option.api })
        .then((modules: any) => {
          const module = modules[0]
          moduleStore[name] = module
          resolve(module)
        })
        .catch((e: any) => {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject({ msg: `load modules ${name} failed`, err: e })
        })
    }
  })
  return promise
}

// 创建三维视图
export const createSceneView = async (id: string) => {
  try {
    mapStore.setGlobalLoading(true)
    init().then(() => {
      const promiseList: any = []
      appConfig.base3dMap.forEach((ele: any) => {
        ele.children.forEach((f: any) => {
          promiseList.push(createLayer(f))
        })
      })
      Promise.all(promiseList)
        .then(async (layerList: any) => {
          const viewingMode = appConfig.mapInitParam.viewingMode === "" ? "local" : appConfig.mapInitParam.viewingMode

          const [Basemap, Map, SceneView] = await getModules(["esri/Basemap", "esri/Map", "esri/views/SceneView"])

          // 高程图层需单独提出
          const elevationList: any = []
          const baseLayers: any = []
          layerList.forEach((layer: any) => {
            if (layer.type === "elevation") {
              elevationList.push(layer)
            } else {
              baseLayers.push(layer)
            }
          })
          const customBasemap = new Basemap({
            baseLayers
          })
          const layers = appConfig.activeView.map.layers
          const map = new Map({
            basemap: customBasemap,
            layers,
            ground: {
              layers: elevationList,
              // surfaceColor: "#0c323f",
              navigationConstraint: {
                type: "none"
              }
            }
          })

          const sceneView = new SceneView({
            container: id,
            map,
            camera: {
              heading: appConfig.mapInitParam.extent3D.heading,
              position: {
                x: appConfig.mapInitParam.extent3D.x,
                y: appConfig.mapInitParam.extent3D.y,
                z: appConfig.mapInitParam.extent3D.z,
                spatialReference: appConfig.activeView.spatialReference
              },
              tilt: appConfig.mapInitParam.tilt
            },
            viewingMode,
            spatialReference: appConfig.activeView.spatialReference
          })

          sceneView.ui.remove("attribution")
          sceneView.ui.empty("top-left")
          sceneView.ui.empty("top-right")
          if (appConfig.activeId === "detail-id") {
            appConfig.setDetailSceneView(sceneView)
          } else {
            appConfig.setSceneView(sceneView)
          }
          appConfig.changeView(sceneView)
        })
        .finally(() => {
          mapStore.setGlobalLoading(false)
          mapStore.setLoading2dFinish(true)
        })
    })
  } catch (err) {
    console.log(err)
    mapStore.setGlobalLoading(false)
  }
}
// 创建二维视图
export const createMapView = async (div: any) => {
  try {
    mapStore.setLoading2dFinish(false)
    mapStore.setGlobalLoading(true)
    init().then(() => {
      const promiseList: any = []
      appConfig.baseMap.forEach((ele: any) => {
        ele.children.forEach((f: any) => {
          promiseList.push(createLayer(f))
        })
      })
      Promise.all(promiseList)
        .then(async (layers: any) => {
          const mapInitParam = appConfig.mapInitParam
          const spatialReference = str2JSON(mapInitParam?.mapConfig?.spatialReference)
          const extent = {
            xmin: mapInitParam?.extent2D?.xMin,
            ymin: mapInitParam?.extent2D?.yMin,
            xmax: mapInitParam?.extent2D?.xMax,
            ymax: mapInitParam?.extent2D?.yMax,
            spatialReference
          }
          let constraints = null
          if (mapInitParam.constraint && mapInitParam.constraint !== "") {
            constraints = str2JSON(mapInitParam.constraint)
            mapInitParam.constraints = constraints
            // 解析后的constraints，保存起来三维创建可以直接使用
            appConfig.setMapInitParam(mapInitParam)
          }
          // 设置最大缩放，过滤掉不可展示的区域
          constraints.maxScale = 2000
          const [Basemap, Map, MapView] = await getModules(["esri/Basemap", "esri/Map", "esri/views/MapView"])
          const customBasemap = new Basemap({
            baseLayers: layers
          })
          const map = new Map({
            basemap: customBasemap
          })
          const mapView = new MapView({
            container: div,
            map,
            spatialReference,
            extent,
            ...(constraints && { constraints })
          })

          mapView.ui.remove("attribution")
          mapView.ui.empty("top-left")
          mapView.ui.empty("top-right")

          if (appConfig.activeId === "detail-id") {
            appConfig.setDetailMapView(mapView)
          } else {
            appConfig.setMapView(mapView)
          }
          appConfig.changeView(mapView)
        })
        .finally(() => {
          mapStore.setGlobalLoading(false)
          mapStore.setLoading2dFinish(true)
        })
    })
  } catch (err) {
    console.log(err)
    mapStore.setGlobalLoading(false)
  }
}
